module.exports = __webpack_public_path__ + "static/media/bfile-savings-account.eaf53f11.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/bfile-savings-account.svg
// module id = 251
// module chunks = 0